export function getPremiumMap() {
  const creditCardMap = {
    "American Express": 22,
    "Diners Club": 10,
    Discover: 14,
    JCB: 16,
    MasterCard: 2,
    Visa: 1,
  };

  const planMap = {
    "basic_premium-12-month": "12 Months",
    "basic_premium-6-month": "6 Months",
    "basic_premium-1-month": "1 Month",
    basic_premium: "1 Month",
    "": "0",
  };

  const planMapNum = {
    12: "12 Months",
    6: "6 Months",
    1: "1 Month",
    "": "0",
  };

  const durationPlanMap = {
    "basic_premium-12-month": "12",
    "basic_premium-6-month": "6",
    "basic_premium-1-month": "1",
    basic_premium: "1",
  };

  const premiumVersionMapNum = {
    12: "basic_premium-12-month",
    6: "basic_premium-6-month",
    1: "basic_premium-1-month",
  };

  const pricePerMap = {
    "basic_premium-12-month": "year",
    "basic_premium-1-month": "month",
  };

  const termMap = {
    "basic_premium-12-month": "yearly",
    "basic_premium-1-month": "monthly",
  };

  const maps = {
    creditCardMap,
    planMap,
    durationPlanMap,
    premiumVersionMapNum,
    pricePerMap,
    planMapNum,
    termMap,
  };

  return maps;
}

export function formatPremiumPrice(planPricing) {
  let amount = planPricing && planPricing.amount;
  let currency = planPricing && planPricing.currency;

  return `${currency}${amount}`;
}

export function getPlanDurationUnit(months) {
  switch (months) {
    case 1:
      return "month";
    case 12:
      return "year";
    default:
      return "";
  }
}
